import { datadogRum } from '@datadog/browser-rum'

export const pageErrorHandler = (error) => {
  datadogRum.addError(error)
}
